module.exports = __webpack_public_path__ + "static/media/heroku.86b00b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/heroku.png
// module id = 1494
// module chunks = 0